export function setupSiteDropdown() {
    const btn = document.querySelectorAll(".site-dropdown button");

    for (let i = 0; btn.length > i; i++) {
        btn[i].addEventListener("click", function() {
            buttonClicker(btn[i]);
        });
    }

    // If the dropdown is showing, monitor it for change and set the hidden input
    const siteDropdown = document.querySelectorAll(".js-site");
    const siteInput = document.querySelector(".site-dropdown-input");
    for (let i = 0; siteDropdown.length > i; i++) {
        siteDropdown[i].onchange = function() {
            siteInput.value = siteDropdown[i].options[siteDropdown[i].selectedIndex].value;
        };
    }
}

function buttonClicker(clickedBtn) {
    const siteInput = document.querySelector(".site-dropdown-input");
    // Remove the active class from all buttons
    const btn = document.querySelectorAll(".site-dropdown button");
    for (let i = 0; btn.length > i; i++) {
        btn[i].classList.remove("active");
    }
    clickedBtn.classList.add("active");

    // Hide all the dropdowns
    const site = document.querySelectorAll(".js-site");
    for (let i = 0; site.length > i; i++) {
        site[i].style.display = "none";
    }

    // Figure out which dropdown to show based on the button clicked
    const clickedBtnType = clickedBtn.dataset.type;
    let siteDropdown;
    if (!clickedBtnType) {
        siteDropdown = document.querySelector(".js-site"); // There is no dropdown associated with the button
    } else {
        siteDropdown = document.querySelector(`.js-site.${clickedBtnType.toLowerCase()}`);
    }

    if (clickedBtnType === "hospital" || clickedBtnType === "partner") {
        siteDropdown.style.display = "block"; // Show the dropdown
        siteInput.value = siteDropdown.options[siteDropdown.selectedIndex].value; // Set the site id of the hidden input
    } else {
        siteDropdown.style.display = "none";
        siteInput.value = clickedBtn.dataset.blogId; // Set the site id of the hidden input
    }
}
